import React, { useState } from "react";
import "./workHistory.css";
import { PiGraduationCapBold } from "react-icons/pi";
import { MdOutlineWorkOutline } from "react-icons/md";
import { FiCalendar } from "react-icons/fi";

const WorkHistory = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section id="work_history">
      <h5>My Professional Journey</h5>
      <h2>Work History</h2>

      <div className="container work_history_container">
        <div className="work_tabs">
          <div
            className={
              toggleState === 1 ? "work_buttons work_active" : "work_buttons"
            }
            onClick={() => toggleTab(1)}
          >
            <PiGraduationCapBold className="work_icon heading_icons" />
            Education
          </div>

          <div
            className={
              toggleState === 2 ? "work_buttons work_active" : "work_buttons"
            }
            onClick={() => toggleTab(2)}
          >
            <MdOutlineWorkOutline className="work_icon heading_icons" />
            Work Experience
          </div>
        </div>

        <div className="work_sections">
          <div className="work_content">
            <div className="work_data">
              <div>
                <h3 className="work_title">B.Tech Information Technology</h3>
                <span className="work_subtitle">
                  PSIT college Of Engineering
                </span>

                <div className="work_calender">
                  <FiCalendar className="work_icon" />
                  Aug 2019 - Jul 2023
                </div>
                <span className="work_subtitle work_score">
                  CGPA : 8.4 | Aggregate : 80 %
                </span>
              </div>

              <div>
                <span className="work_rounder"></span>
                <span className="work_line"></span>
              </div>
            </div>

            <div className="work_data">
              <div></div>

              <div>
                <span className="work_rounder"></span>
                <span className="work_line"></span>
              </div>

              <div>
                <h3 className="work_title">Associate Software Engineer</h3>
                <span className="work_subtitle">Nagarro</span>

                <div className="work_calender">
                  <FiCalendar className="work_icon" />
                  Jan 2023 - Present
                </div>
                <span className="work_subtitle work_score">
                  Tech : Angular, React.js, ASP.NET, Azure, SQL
                </span>
              </div>
            </div>

            <div className="work_data">
              <div>
                <h3 className="work_title">Senior Secondary School</h3>
                <span className="work_subtitle">
                  Kamad Saraswati Inter College
                </span>

                <div className="work_calender">
                  <FiCalendar className="work_icon" />
                  Apr 2017 - Mar 2018
                </div>
                <span className="work_subtitle work_score">
                  Aggregate : 87.8 %
                </span>
              </div>

              <div>
                <span className="work_rounder"></span>
                <span className="work_line"></span>
              </div>
            </div>

            <div className="work_data">
              <div></div>

              <div>
                <span className="work_rounder"></span>
                <span className="work_line"></span>
              </div>

              <div>
                <h3 className="work_title">Web Development Intern</h3>
                <span className="work_subtitle">Oasis Infobyte</span>

                <div className="work_calender">
                  <FiCalendar className="work_icon" />
                  Apr 2022 - May 2022
                </div>
                <span className="work_subtitle work_score">
                  Tech : JavaScript, Bootstrap, HTML5, CSS3
                </span>
              </div>
            </div>

            <div className="work_data">
              <div>
                <h3 className="work_title">Secondary School</h3>
                <span className="work_subtitle">
                  Kamad Saraswati Inter College
                </span>

                <div className="work_calender">
                  <FiCalendar className="work_icon" />
                  Apr 2015 - May 2016
                </div>
                <span className="work_subtitle work_score">
                  Aggregate : 91 %
                </span>
              </div>

              <div>
                <span className="work_rounder"></span>
                <span className="work_line"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkHistory;
